<template>
    <svg version="1.1"
         id="Layer_1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px"
         y="0px"
         viewBox="0 0 24 24"
         style="enable-background:new 0 0 24 24;"
         :width="width"
         :height="height"
         xml:space="preserve"
    >
        <rect x="0" y="0" class="st0" style="fill:none;" :width="width" :height="height"/>
        <path class="st1" :style="{fill:color}" d="M5,9l1.4,1.4L11,5.8V22h2V5.8l4.6,4.6L19,9l-7-7L5,9z"/>
    </svg>
</template>

<script>
export default {
    name: "ExpandIcon",
    props: {
        width: {
            type: Number,
            default: 24,
        },
        height: {
            type: Number,
            default: 24
        },
        color: {
            type: String,
            default: '#212121'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/ArrowUpDiUpgradeIcon.vue